import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';
import { Router } from '@angular/router';

type InputTypes =
  | 'text'
  | 'password'
  | 'email'
  | 'money'
  | 'date'
  | 'datetime-local'
  | 'number'
  | 'mask'
  | 'select'
  | 'select-table'
  | 'search'
  | 'disabled'
  | 'textarea'
  | 'month'
  | 'only-text';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements OnInit {
  @Input() type: InputTypes = 'text';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() maxLength: string | null = null;
  @Input() width: string = '';
  @Input() mask: string = '';
  @Input() name: string = '';
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() requiredInput: boolean = false;
  @Input() selectData: any[] = [];
  @Input() ngModel: any;
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  @Output() blurEvent: EventEmitter<void> = new EventEmitter();
  passwordType: string = 'password';
  eyeImage: string = 'assets/eye-icon.png';

  value: any = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    if (this.maxLength === '') {
      this.maxLength = null;
    }

    if (
      (this.type === 'select' && this.value === '') ||
      (this.type === 'select-table' && this.value === '')
    ) {
      this.value = '';
      this.onSelectChange(this.value);
    }
  }

  constructor(private router: Router) {}

  togglePassword() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    this.eyeImage = 'assets/eye-icon.png';
  }

  onSelectChange(value: any) {
    this.value = value === '' ? null : value;
    this.ngModelChange.emit(value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.readOnly = isDisabled;
    this.disabled = isDisabled;
  }

  onValueChange(value: string | any) {
    if (typeof value === 'string' || typeof value === 'number') {
      this.value = value;
      this.onChange(this.value);
      this.onTouched();
    }

    this.ngModelChange.emit(this.value);
  }

  onFocus() {
    this.onTouched();
  }

  onBlur() {
    this.onTouched();
    this.blurEvent.emit();
  }

  onDateNow() {
    const date = new Date();
    return date.toISOString().slice(0, 16);
  }

  applyMask(event: KeyboardEvent): void {
    const key = event.key;
    const regex = /^[a-zA-ZÀ-ÿ\\s ]*$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }
}
